const down = (maxWidth) => `@media (max-width: ${maxWidth}px)`;
const hover = () => `@media (hover: hover) and (pointer: fine)`;
export const media = {
    mobileDown: down(480 /* MOBILE */),
    tabletDown: down(800 /* TABLET */),
    desktopDown: down(1280 /* DESKTOP */),
    wideDown: down(1600 /* WIDE */),
    cinemaDown: down(10000 /* CINEMA */),
    hover: hover(),
};

